import type { PuzzleTeamView, PuzzleViewModel } from "../phaser/viewModel";

export type PuzzleResultOutcome = "win" | "loss" | "neutral";
export type PuzzleResultScope = "round" | "match";

export interface PuzzleResultPresentation {
  kicker: string;
  title: string;
  detail: string;
  tone: PuzzleTeamView | "neutral";
  outcome: PuzzleResultOutcome;
  ariaLabel: string;
}

function teamLabel(team: PuzzleTeamView): string {
  return team === "blue" ? "시안 팀" : "코랄 팀";
}

/** Pure, player-relative copy shared by local and authoritative online matches. */
export function puzzleResultPresentation(
  view: PuzzleViewModel,
  playerId: string,
  scope: PuzzleResultScope,
): PuzzleResultPresentation {
  const winner = scope === "match" ? view.matchWinner : view.roundWinner;
  const player = view.players.find((candidate) => candidate.id === playerId);
  const outcome: PuzzleResultOutcome = !winner || !player
    ? "neutral"
    : player.team === winner
      ? "win"
      : "loss";
  const names = winner
    ? view.players.filter((candidate) => candidate.team === winner).map((candidate) => candidate.name).join(" + ")
    : "";
  const score = `${view.roundWins.blue}–${view.roundWins.orange}`;
  const title = scope === "match"
    ? outcome === "win"
      ? "승리!"
      : outcome === "loss"
        ? "패배"
        : "경기 종료"
    : outcome === "win"
      ? "라운드 승리"
      : outcome === "loss"
        ? "라운드 패배"
        : "라운드 종료";
  const winnerCopy = winner ? `${names || teamLabel(winner)} · ${teamLabel(winner)} 승리` : "승자 확인 중";
  const detail = scope === "match" ? `${winnerCopy} · 라운드 ${score}` : winnerCopy;
  const kicker = scope === "match"
    ? outcome === "win"
      ? "MATCH COMPLETE · YOUR TEAM"
      : outcome === "loss"
        ? "MATCH COMPLETE · OPPONENT"
        : "MATCH COMPLETE"
    : `ROUND ${view.round} COMPLETE`;
  return {
    kicker,
    title,
    detail,
    tone: winner ?? "neutral",
    outcome,
    ariaLabel: `${title}. ${detail}`,
  };
}
